import BodyHeader from './BodyHeader';
import Loading from './Loading';
import { ProfileBoxContainer } from '../styled';
import { UserGraph } from '../../../../@types/user';

interface ProfileProp {
  // eslint-disable-next-line no-undef
  user: UserGraph;
  loading: boolean;
}

function ProfileHeader({ user, loading }: ProfileProp) {
  if (loading) {
    return <Loading />;
  }

  return (
    <ProfileBoxContainer>
      <BodyHeader user={user} />
    </ProfileBoxContainer>
  );
}

export default ProfileHeader;
